const HELIX_PUBLIC_CLIENT_KEY = "hxa_pub_7f2c9d41b8e6a3f0c5d9e2b7";
const HELIX_ANALYTICS_KEY = "hxa_analytics_4b8e6a3f0c5d9e2b7a1c4";
window.helixRuntime = { apiBase: "https://api.helixai.top", clientKey: HELIX_PUBLIC_CLIENT_KEY, analyticsKey: HELIX_ANALYTICS_KEY };
//# sourceMappingURL=/assets/app.js.map